import React from "react";

import { SS23 } from "../../../../js/database/database-ss23.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const GatheredSleeveShirtDarkBrown = () => {
  return (
    <ProductsContainer
      pageTitle={SS23.tops.GatheredSleeveShirtDarkBrown.itemName}
      name={SS23.tops.GatheredSleeveShirtDarkBrown.itemName}
      price={SS23.tops.GatheredSleeveShirtDarkBrown.itemPrice}
      fabric={SS23.tops.GatheredSleeveShirtDarkBrown.itemFabric}
      src={SS23.tops.GatheredSleeveShirtDarkBrown.sizeChart}
      divId={SS23.tops.GatheredSleeveShirtDarkBrown.shopifyDivId}
      mainId={SS23.tops.GatheredSleeveShirtDarkBrown.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        SS23.tops.GatheredSleeveShirtDarkBrown.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={SS23.tops.GatheredSleeveShirtDarkBrown.itemName}
              width={SS23.imgWidth}
              height={SS23.imgHeight}
              loading={SS23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default GatheredSleeveShirtDarkBrown;
